import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";
import { A6EventsEdit } from "./edit";
import { A6EventsNew } from "./new";
import { A6EventsTable } from "./table";

export default function A6Events() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Events");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A6EventsEdit />} />
      <Route index element={<A6EventsTable />} />
      <Route path="/new" element={<A6EventsNew />} />
    </Routes>
  );
}
